// extracted by mini-css-extract-plugin
export default {"portalManagementContainer":"styles_portalManagementContainer__Cw64Z"};